import { render, staticRenderFns } from "./EditContentModal.vue?vue&type=template&id=13b9520d&"
import script from "./EditContentModal.vue?vue&type=script&lang=js&"
export * from "./EditContentModal.vue?vue&type=script&lang=js&"
import style0 from "./EditContentModal.vue?vue&type=style&index=0&id=13b9520d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports